import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.6104 7.71426C17.9992 7.3221 17.9992 6.68628 17.6104 6.29412C17.2215 5.90196 16.591 5.90196 16.2021 6.29412L12 10.5317L7.79785 6.29412C7.40897 5.90196 6.77847 5.90196 6.38959 6.29412C6.00071 6.68628 6.00071 7.3221 6.38959 7.71426L10.5917 11.9518L6.29276 16.287C5.90388 16.6792 5.90388 17.315 6.29276 17.7071C6.68164 18.0993 7.31214 18.0993 7.70102 17.7071L12 13.3719L16.2989 17.7071C16.6878 18.0993 17.3183 18.0993 17.7072 17.7071C18.0961 17.315 18.0961 16.6792 17.7072 16.287L13.4082 11.9518L17.6104 7.71426Z"
	})]
});
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
